var Colors = [
    [20 / 255, 20 / 255, 19 / 255, 1],
    [89 / 255, 89 / 255, 89 / 255, 1],
    [20 / 255, 79 / 255, 118 / 255, 1],
    [109 / 255, 54 / 255, 100 / 255, 1],
    [216 / 255, 62 / 255, 88 / 255, 1],
    [242 / 255, 149 / 255, 89 / 255, 1],
    [74 / 255, 45 / 255, 35 / 255, 1],
    [31 / 255, 132 / 255, 122 / 255, 1],

    [239 / 255, 240 / 255, 244 / 255, 1],
    [158 / 255, 157 / 255, 152 / 255, 1],
    [21 / 255, 173 / 255, 224 / 255, 1],
    [181 / 255, 105 / 255, 168 / 255, 1],
    [255 / 255, 130 / 255, 169 / 255, 1],
    [255 / 255, 218 / 255, 133 / 255, 1],
    [134 / 255, 81 / 255, 50 / 255, 1],
    [6 / 255, 214 / 255, 160 / 255, 1],
];

var WallSetup = {
    myFloorCollisionGroup: 3
};